import { render, staticRenderFns } from "./ButtonTile.vue?vue&type=template&id=28df4f6b&scoped=true"
import script from "./ButtonTile.vue?vue&type=script&lang=js"
export * from "./ButtonTile.vue?vue&type=script&lang=js"
import style0 from "./ButtonTile.vue?vue&type=style&index=0&id=28df4f6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28df4f6b",
  null
  
)

export default component.exports